import * as React from 'react';
import type { SVGProps } from 'react';

// This is X the social network logo (previously known as Twitter)
const IconX = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22" {...props}>
    <path
      d="m12.912 9.502 7.85-9.124h-1.86L12.084 8.3 6.642.378H.362l8.233 11.98-8.232 9.569h1.86l7.198-8.367 5.749 8.367h6.278L12.911 9.502Zm-2.548 2.962-.834-1.193-6.637-9.493H5.75l5.356 7.661.834 1.193 6.962 9.958h-2.857l-5.681-8.126Z"
      fill="currentColor"
    />
  </svg>
);
export default IconX;
